import React from 'react';
import { CircularProgress, Grid2 } from '@mui/material';
import { useGetIntegrations } from '@openapi/integrations/integrations';
import { useGetVenue } from '@openapi/venues/venues';
import useNotify from '../../hooks/useNotify';
import PageWithTitle from '../../components/atom/PageWithTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { VENUE_INTEGRATION_TYPES } from '../../helpers/constants';
import IntegrationCard from '../integrations/components/IntegrationCard';

const VenueIntegrationsPage = () => {
    const { t } = useTranslation();
    const { notifyError } = useNotify();
    const { venueId } = useParams();
    const navigate = useNavigate();

    const {
        data,
        isLoading: loading,
        _error,
    } = useGetIntegrations(
        {
            optionalVenueId: venueId,
            pageSize: 100,
        },
        {
            query: {
                onError: notifyError,
            },
        },
    );

    const {
        data: venue,
        isLoading: loadingVenue,
        error: _errorVenue,
    } = useGetVenue(Number(venueId), {
        query: {
            onError: notifyError,
        },
    });

    // Create a map of existing integrations by type
    const integrationsMap = {};
    if (data?.integrations) {
        data.integrations.forEach((integration) => {
            integrationsMap[integration.type] = integration;
        });
    }

    // Build list of ALL venue-scoped integration types (existing + missing)
    const allIntegrations = Object.values(VENUE_INTEGRATION_TYPES).map((type) => {
        if (integrationsMap[type]) {
            return integrationsMap[type];
        }
        // Return a default "disabled" integration if it doesn't exist in DB
        return {
            type,
            settings: {},
            enabled: false,
        };
    });

    return (
        <PageWithTitle
            title={`${t('integrations.title')} (${loadingVenue ? '' : venue?.name || ''})`}
        >
            <Grid2
                container
                spacing={2}
                sx={{
                    width: '100%',
                    margin: 0,
                }}
            >
                {loading && <CircularProgress size={20} style={{ margin: '20px auto' }} />}
                {allIntegrations.map((integration) => (
                    <Grid2 key={integration.type} size={{ xs: 12, sm: 6, md: 3 }}>
                        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <IntegrationCard
                                integration={integration}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/venues/${venueId}/integrations/${integration.type}`);
                                }}
                            />
                        </div>
                    </Grid2>
                ))}
            </Grid2>
        </PageWithTitle>
    );
};

export default VenueIntegrationsPage;
